export default {
    data () {
        return {
            defaultAreaNames: []
        };
    },
    methods: {
        areaNamesListSearch (queryString, cb) {
            let defaultAreaNames = this.defaultAreaNames;
            let results = queryString ? defaultAreaNames.filter(this.createAreaFilter(queryString)) : defaultAreaNames;
            cb(results);
        },
        createAreaFilter (queryString) {
            return (name) => {
                return (name.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        loadAllAreas () {
            if (this.defaultAreaNames.length !== 0) {
                return;
            }
            if (this.userCan('manage-inspections') || this.userCan('manage-maintenance-tickets')) {
                axios.get("/inspections/lists/areas")
                .then(response => {
                    this.defaultAreaNames = response.data;
                });
            }
        },
    },
    mounted () {
        this.loadAllAreas();
    }
};
